import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { startSessionSuccess } from '../actions/session.actions';
import { ExceptionState, SessionState } from '../../types/session';
import { RootState } from '../store';

type State = { exception: true; category: string; message: string } | { exception: false };

const initialState: State = { exception: false } as State;

export const exceptionSlice = createSlice({
	name: 'session/exception',
	initialState,
	reducers: {
		setSessionException(_, action: PayloadAction<{ category: string; message: string }>) {
			const { category, message } = action.payload;

			return {
				exception: true,
				category,
				message
			};
		}
	},
	extraReducers: (builder) => {
		builder.addCase(startSessionSuccess, (inState, action) => {
			const state = action.payload;
			if (!isExceptionState(state)) return inState;

			const error = state.result.error;
			return {
				exception: true,
				category: error.category,
				message: error.message
			};
		});
	}
});

export const { setSessionException } = exceptionSlice.actions;

const isExceptionState = (state: SessionState): state is ExceptionState => {
	return state.status === 'EXCEPTION';
};

// SELECTORS

export const selectExceptionCategory = (state: RootState) => {
	const exception = state.exception;
	if (!exception.exception) return undefined;
	return exception.category;
};

export const selectExceptionMessage = (state: RootState) => {
	const exception = state.exception;
	if (!exception.exception) return undefined;
	return exception.message;
};
